module.exports = __webpack_public_path__ + "static/media/Inter-Black.f2684bce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Inter/Inter-Black.ttf
// module id = 357
// module chunks = 17